export default __webpack_public_path__ + "assets/images/e3ee55e64045b378635b66e940aac11a.jpg";